import { JARGON } from "../data/Jargon"

// Whether this page load is a 350 Club-sourced visit (?source=350club) - read directly from the
// URL here, at module load, rather than relying on a later call (see initBranding in
// pages/home/helpers/homeFunctions.js) to mutate COLOR.BRAND.STD/FILTERS.BLACK_TO_BRAND after the
// fact. Anything that captures those values at its OWN module-load time (e.g. Tabs.js's
// selectedTabStyles, theme.js's MUI palette - both plain objects built once, not re-evaluated per
// render) runs before any React component has mounted, so a mutation from inside a component
// lifecycle (Splash's constructor) always arrives too late for them - they're permanently stuck on
// whatever COLOR.BRAND.STD was at import time. Deciding it correctly right here, up front, means
// there's nothing left for those early consumers to miss.
const isThe350Club = new URLSearchParams(location.search).get("source") === JARGON.THE350CLUB

// set colors using https://material.io/inline-tools/color/
export const COLOR = {
  GOOD: "#27bc13", // "#00A000", // triadic green 600 - NB match in company SVG
  GOOD_LIGHT: "#85dc6d", // triadic green 300
  BAD: "#ff0000", // "#f36827", // analagous orange 500 - NB match in company SVG
  BAD_LIGHT: "#ff9090",
  WARN: "#ff8000", // "#f36827", // analagous orange 500
  FUTURE: "#0000FF", // blue,"
  BRAND: {
    NUMERABLE: location.host === "localhost:3000"
      ? "#4060C0" // Blue
      : location.host === "localhost:3001"
        ? "#3c7b7c" // Sea green
        : "#6152aa", // Numerable brand purple
    NUMERABLE_LIGHT: location.host === "localhost:3000"
      ? "#E0F0FF" // Light blue
      : location.host === "localhost:3001"
        ? "#eefcfc" // Light sea green
        : "#f4f0fc", // Numerable brand light purple

    THE350CLUB: "#2E2828", // "#d0043c", // 350 Club brand dark colour
    THE350CLUB_LIGHT: "#FDFAF3", // "#fff0f0", // 350 Club brand light colour
    STD: "", // Re-defined below - if {} we get ts warning "Type '{}' is not assignable to type 'string'" in Theme
    LIGHT: "", // Re-defined below
  },
  // greys
  UNKNOWN: "#808080", // mid grey
  BLACK: "#000000", // black
  VERY_DARK_GREY: "#404040",
  DARK_GREY: "#606060",
  MID_GREY: "#808080",
  LIGHT_GREY: "#d0d0d0",
  VERY_LIGHT_GREY: "#f2f2f2",
  WHITE: "#ffffff",
  DISABLED: "#ccc",

  NAVBAR_TEXT: "white",
  BACKGROUND: "white",

  PDF: {
    veryLightGrey: "#f5f5f5",
    lightGrey: "#e0e0e0",
    greyText: "#757575",
    darkGreyText: "#424242",
    veryDarkGreyText: "#212121",
    legendGreen: "#00642e",
  },
}

// Init branding defaults
COLOR.BRAND.STD = isThe350Club ? COLOR.BRAND.THE350CLUB : COLOR.BRAND.NUMERABLE
COLOR.BRAND.LIGHT = isThe350Club ? COLOR.BRAND.THE350CLUB_LIGHT : COLOR.BRAND.NUMERABLE_LIGHT

// find filter values at: https://stackoverflow.com/questions/42966641/how-to-transform-black-into-any-given-color-using-only-css-filters/43960991#43960991
export const FILTERS = {
  BLACK_TO_NUMERABLE_PURPLE: "invert(37%) sepia(42%) saturate(765%) hue-rotate(210deg) brightness(89%) contrast(95%)",
  BLACK_TO_350CLUB_COLOR:
    "invert(10%) sepia(5%) saturate(1649%) hue-rotate(315deg) brightness(92%) contrast(83%)", // new color Dec 23
  // "invert(14%) sepia(99%) saturate(7025%) hue-rotate(339deg) brightness(82%) contrast(98%)", // old color

  // NB match filters below to actual colors set for tense
  BLACK_TO_GOOD: "invert(57%) sepia(63%) saturate(3213%) hue-rotate(76deg) brightness(99%) contrast(90%)",
  BLACK_TO_BAD: "invert(11%) sepia(93%) saturate(7291%) hue-rotate(6deg) brightness(106%) contrast(114%)",
  BLACK_TO_WARN: "invert(56%) sepia(91%) saturate(2830%) hue-rotate(0deg) brightness(102%) contrast(106%)",

  // NB match filters below to actual colors set for sex
  BLACK_TO_MALE_COLOR: "invert(37%) sepia(13%) saturate(6788%) hue-rotate(174deg) brightness(103%) contrast(78%)",
  BLACK_TO_FEMALE_COLOR: "invert(27%) sepia(60%) saturate(1770%) hue-rotate(296deg) brightness(92%) contrast(90%)",

  // Back to COLOR.UNKNOWN (Currently "#808080" - mid grey)
  BLACK_TO_UNKNOWN: "invert(48%) sepia(16%) saturate(6%) hue-rotate(47deg) brightness(101%) contrast(87%)",
  BLACK_TO_BRAND: {}, // Defined below
}

FILTERS.BLACK_TO_BRAND = isThe350Club ? FILTERS.BLACK_TO_350CLUB_COLOR : FILTERS.BLACK_TO_NUMERABLE_PURPLE
